// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"bb84fae7","100":"90485415","211":"3bad8f4e","587":"715b51a0"}[chunkId] + ".chunk.css";
};